import { createHook } from '../index.tsx';
import { getTimelineViewSectionMessageDismissed } from './timeline-view-spotlight.tsx';

export const useTimelineSectionMessageDismissed = createHook(
	getTimelineViewSectionMessageDismissed,
);
